import { FC, ReactElement } from 'react'

import { WorkOrderReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import {
  IconChecklistChecked,
  IconChecklistEmpty,
  IconChecklistHalfChecked,
} from '@avantstay/backoffice-vectors'

import { mainColors, semanticColors } from '../../styles'
import { Tooltip } from '../Tooltip'
import * as S from './ChecklistStatus.styles'

interface CheckListStatusProps {
  checklistStatus: WorkOrderReadinessStatus
}

const iconByChecklistStatus: Record<string, ReactElement> = {
  [WorkOrderReadinessStatus.completed]: <IconChecklistChecked />,
  [WorkOrderReadinessStatus.inProgress]: <IconChecklistHalfChecked />,
  [WorkOrderReadinessStatus.notStarted]: <IconChecklistEmpty />,
  [WorkOrderReadinessStatus.notNeeded]: <IconChecklistChecked />,
}

const iconColorByChecklistStatus: Record<string, string> = {
  [WorkOrderReadinessStatus.completed]: semanticColors.successMedium,
  [WorkOrderReadinessStatus.inProgress]: semanticColors.successMedium,
  [WorkOrderReadinessStatus.notStarted]: mainColors.white,
  [WorkOrderReadinessStatus.notNeeded]: semanticColors.successMedium,
}

const titleByChecklistStatus: Record<string, string> = {
  [WorkOrderReadinessStatus.completed]: 'Completed',
  [WorkOrderReadinessStatus.inProgress]: 'In Progress',
  [WorkOrderReadinessStatus.notStarted]: 'Not Started',
  [WorkOrderReadinessStatus.notNeeded]: 'Completed',
}

export const ChecklistStatus: FC<CheckListStatusProps> = ({ checklistStatus }) => {
  return (
    <Tooltip content={titleByChecklistStatus[checklistStatus]} placement="top">
      <S.IconWrapper color={iconColorByChecklistStatus[checklistStatus] ?? mainColors.neutralDark}>
        {iconByChecklistStatus[checklistStatus] ?? <IconChecklistEmpty opacity={0.4} />}
      </S.IconWrapper>
    </Tooltip>
  )
}
